import { useStore } from 'vuex';
import { computed } from 'vue';
import axios        from "axios";

import { getElementOffset } from "../Utils";




export async function isSessionLoggedIn ( store )
{
    //let store    = useStore();
    let copydeck = computed( () => store.state.copydeck );

    if ( store && store.getters.isAutheticated )
    {
        return true;
    }


    let worked = false;

    try
    {

        if (store.getters.isAutheticated)
        {
            return true;
        }

        const response = await axios.get( '/usercheck' );

        // console.log( 'Inside IsSessionLoggedIn. the response was', response, 'the store is', store );

        store.commit( 'authenticateUser', response.data );

        worked = true;

    }
    catch (error)
    {
        console.log(error);

        if ( error.response )
        {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            //console.log('isSessionLoggedIn:catch:error.response', error.response.data);
            //console.log('isSessionLoggedIn:catch:error.response', error.response.status);
            //console.log('isSessionLoggedIn:catch:error.response', error.response.headers);


        } else if ( error.request )
        {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            //console.log('error.request', error.request);
        } else
        {
            // Something happened in setting up the request that triggered an Error
            //console.log('Error', error.message);
        }


    }

    return worked;
}


export function smoothScrollTo ( destinationElement, offset = -50 )
{

    // console.log('destinationElement: ' , destinationElement, getElementOffset( destinationElement ))

    window.scrollTo( {
        top      : getElementOffset( destinationElement ).top + offset,
        left     : 0,
        behavior : 'smooth',
    } );


}


export function getCommentConnector() {
    return '<svg class="comments-connector" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 31 50" viewBox="0 0 31 50"><path d="M31 48h-1C14.6 48 2 35.4 2 20V0H0v20c0 16.5 13.5 30 30 30h1v-2z" style="fill: var(--page-theme-colour);"/></svg>';
}


